import {NgModule} from '@angular/core';
import {NgbDatepickerModule, NgbPopoverModule, NgbDropdownModule, NgbModule, NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {PositiveValue} from './../../common/filters/positiveValue.pipe';
import {SafeHtmlPipe} from './../../common/pipe/htmlSanitize.pipe';


import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatRadioModule} from '@angular/material/radio';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatInputModule} from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSortModule} from '@angular/material/sort';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatListModule} from '@angular/material/list';

import {ModuleWithProviders} from '@angular/core';

@NgModule({
  declarations: [
    PositiveValue,
    SafeHtmlPipe
  ],
  imports: [
    MatTabsModule,
    MatTableModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatPaginatorModule,
    MatRadioModule,
    MatBottomSheetModule,
    MatSidenavModule,
    MatInputModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbModule,
    NgbTooltip,
    MatSortModule,
    MatDialogModule,
    MatExpansionModule,
    MatTooltipModule,
    MatMenuModule,
    MatListModule
  ],
  exports: [
    MatTabsModule,
    MatTableModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatPaginatorModule,
    MatRadioModule,
    MatBottomSheetModule,
    MatSidenavModule,
    MatInputModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbModule,
    NgbTooltip,
    MatSortModule,
    MatDialogModule,
    MatExpansionModule,
    MatTooltipModule,
    MatMenuModule,
    PositiveValue,
    SafeHtmlPipe,
    MatListModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule
    };
  }
}
